import PrivateRouter from "router/PrivateRouter"

const PrivateContainer = () => {
  return (
    <PrivateRouter />
  )
}
 export default PrivateContainer